import { FormControlLabel, formControlLabelClasses } from '@mui/material'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'

export const FlexContainer = styled('div')({
  display: 'flex',
})

export const FlexContainerCenter = styled('div')({
  display: 'flex',
  alignItems: 'center',
})

export const EllipsisTypography = styled(Typography)({
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  display: '-webkit-box',
  lineClamp: 2,
  boxOrient: 'vertical',
})

export const CenteredContainer = styled('div')({
  textAlign: 'center',
})

export const SpacingContainer = styled('div')<{ spacing?: number }>(({ spacing = 1, theme }) => ({
  paddingTop: theme.spacing(spacing),
}))

export const exitButtonOptions: {
  label: string
  status: 'save' | 'exit'
  tooltip: string
  id: string
  exitLabel: string
}[] = [
  {
    label: 'Save & Continue later',
    exitLabel: 'Save & Keep Survey Open',
    status: 'save',
    tooltip: 'Save & Continue later',
    id: 'cati-save-continue-btn',
  },
  {
    label: 'Save & Close Permanently',
    exitLabel: 'Save & Close Survey Permanently',
    status: 'exit',
    tooltip: 'Save & Close Permanently',
    id: 'cati-save-close-btn',
  },
]

export const StyledFormControlLabel = styled(FormControlLabel)({
  alignItems: 'flex-start',
  display: 'flex',

  [`& .${formControlLabelClasses.label}`]: {
    marginTop: 10, // so the text aligns with the checkbox/radio
    whiteSpace: 'pre-line',
  },
})
